import type { PartyDetail } from '../../types/api';

/**
 * Pure preview of what a party merge will do, given the two detail rows.
 * Lives in its own module so it can be unit-tested without dragging the
 * React tree along, and so the drawer file only exports components (keeps
 * Vite's fast-refresh happy).
 */
export interface MergePreview {
  newAliases: string[];
  addCanonicalAsAlias: boolean;
}

export function buildMergePreview(
  survivor: PartyDetail | undefined,
  absorb: PartyDetail | undefined,
): MergePreview | null {
  if (!survivor || !absorb) return null;
  const survivorAliases = new Set(survivor.aliases.map((a) => a.alias));
  const newAliases = absorb.aliases
    .map((a) => a.alias)
    .filter((a) => !survivorAliases.has(a));
  const canonicalAlreadyKnown =
    survivorAliases.has(absorb.party.canonical_name) ||
    survivor.party.canonical_name === absorb.party.canonical_name;
  return {
    newAliases,
    addCanonicalAsAlias: !canonicalAlreadyKnown,
  };
}
